module.exports = __webpack_public_path__ + "static/media/icon_add_conditional.dfdb7e52.svg";